<template>
  <div :class="cssClasses">
    <slot name="label"></slot>
    <slot name="field"></slot>
    <slot name="note"></slot>
  </div>
</template>

<script>
export default {
  name: 'field',
  props: {
    type: {
      default: '',
      type: String
    }
  },
  computed: {
    cssClasses () {
      return {
        'field': true,
        'full-width': this.type.indexOf('full-width') > -1,
        'small-field': this.type.indexOf('small-field') > -1
      };
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.field {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  max-width: 1000px;
  padding: 1rem 0;
  width: 100%;

  label {
    padding-right: 2rem;
    text-align: right;
    width: 33.333333%;
  }

  input,
  select,
  textarea {
    width: 33.333333%;

    &[disabled] {
      background: $color-bg-light;
      opacity: .5;
    }
  }

  &.text-center {
    justify-content: center;
  }

  small.note {
    color: $color-text-light;
    display: block;
    padding: .5rem 0 0 33.333333%;
    width: 100%;
  }

  input {
    background: $color-bg-lightest;
    border: 1px solid $color-border;
    border-radius: $border-radius-small;
    font-size: 1.4rem;
    margin: 0;
    padding: 1rem;

    &::-webkit-input-placeholder {
      color: $color-text-lightest;
    }

    &::-moz-placeholder {
      color: $color-text-lightest;
    }

    &:-ms-input-placeholder {
      color: $color-text-lightest;
    }

    &:-moz-placeholder {
      color: $color-text-lightest;
    }

    &.is-invalid {
      border-color: $color-danger;
      color: $color-danger;

      & + .note {
        color: $color-danger;
      }
    }
  }

  select {
    &.is-invalid {
      border-color: $color-danger;
      color: $color-danger;

      & + .note {
        color: $color-danger;
      }
    }
  }

  .note {
    &.is-error,
    &.is-invalid {
      color: $color-danger;
    }
  }

  &.small-field {
    input,
    select,
    textarea {
      min-width: 100px;
      width: 10%;
    }
  }

  &.full-width {
    input,
    select,
    textarea {
      width: 66.66666%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Field.vue